import { render } from "./mini-audio-informer.vue?vue&type=template&id=e50e2192&ts=true"
import script from "./mini-audio-informer.vue?vue&type=script&lang=ts"
export * from "./mini-audio-informer.vue?vue&type=script&lang=ts"

import "./mini-audio-informer.vue?vue&type=style&index=0&id=e50e2192&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__